import PropTypes from "prop-types";
import React from "react";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import SectionTitle from "../../components/section-title/SectionTitle";
import ProductGrid from "./ProductGrid";
import { useDispatch, useSelector } from "react-redux";
import ProductGridSingle from "../../components/product/ProductGridSingle";
const TabProduct = ({
                      spaceTopClass,
                      spaceBottomClass,
                      bgColorClass,
                      category,
                    }) => {
  const { products } = useSelector(({ productData }) => productData);
  const cartItems = useSelector(({ cartData }) => cartData);
  const currencyData = useSelector(({ currencyData }) => currencyData);
  const filteredProducts = products;

  // if (filteredProducts.length > 0) {
    return (
      <div
        className={`product-area ${spaceTopClass ? spaceTopClass : ""} ${
          spaceBottomClass ? spaceBottomClass : ""
        } ${bgColorClass ? bgColorClass : ""}`}
      >
        <div className="container">
          <SectionTitle titleText="Paseos Destacados" positionClass="text-center" />
          <div className="row pt-70 pb-70" style={{justifyContent:'space-evenly'}}>
            {filteredProducts &&
            filteredProducts.map((product) => {
              return (
                <ProductGridSingle
                  spaceBottomClass="mb-25"
                  product={product}
                  currency={currencyData}
                  cartItem={
                    cartItems.filter(
                      (cartItem) => cartItem.id === product.id
                    )[0]
                  }
                  key={product.id}
                />
              );
            })}
          </div>
        </div>
      </div>
    );
  // }
  // return <></>;
};

TabProduct.propTypes = {
  bgColorClass: PropTypes.string,
  category: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
};

export default TabProduct;